import React, { useState } from 'react';
import '../WidgetEditTypes/TopWidgetEdit.css';
import ResponsiveFontControls from './ResponsiveFontControls';

function FontSettingsSection({ fontConfig = [], editData, handleInputChange }) {
    const [isExpanded, setIsExpanded] = useState(false);
    
    // Early return if no font config provided
    if (!fontConfig || fontConfig.length === 0) {
        return null;
    }

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };
    
    return (
        <div>
            {/* Standard Fonts Header mit Toggle */}
            <div 
                className="elegant-input-container clickable-toggle"
                onClick={!isExpanded ? toggleExpanded : undefined}
            >
                <div className="elegant-input-header">
                    <div className="elegant-label-row">
                        <label className="elegant-input-label">Font Settings</label>
                        <button 
                            type="button"
                            className={`elegant-dots-toggle ${isExpanded ? 'expanded' : ''}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleExpanded();
                            }}
                            title="Font Settings"
                        >
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                        </button>
                    </div>
                    {isExpanded && (
                        <div className="elegant-input-controls expanded">
                            <div className="input-container"> 
                                {fontConfig.map((fontItem, index) => (
                                    <ResponsiveFontControls
                                        key={index}
                                        label={fontItem.label}
                                        sizeField={fontItem.sizeField}
                                        weightField={fontItem.weightField}
                                        editData={editData}
                                        handleInputChange={handleInputChange}
                                        defaultSize={fontItem.defaultSize}
                                        defaultWeight={fontItem.defaultWeight}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default FontSettingsSection;
